import { Route, Routes } from 'react-router-dom';

import { useMatter } from '@/hooks/useMatter';

import { ArtifactDetailPage } from './ArtifactDetailPage';
import { ArtifactListPage } from './ArtifactListPage';

export const ArtifactRoutes = () => {
  const { matterId } = useMatter();

  return (
    <Routes>
      <Route path="/" element={<ArtifactListPage matterId={matterId} />} />
      <Route
        path="/:artifact_id"
        element={<ArtifactDetailPage matterId={matterId} />}
      />
    </Routes>
  );
};
